import { apiRequest } from 'utils/request'

export default {
  getModules: () => {
    const uri = '/odx/environments/modules'
    return apiRequest({ uri })
  },
  getModuleVariants: ({ module }) => {
    const uri = `/odx/environments/modules/${module}/variants`
    return apiRequest({ uri })
  },
  getVariantDomains: ({ module, variant }) =>
    apiRequest({
      uri: `/odx/environments/modules/${module}/variants/${variant}/vcd-qualifiers`,
    }),
  getFragmentDetails: ({ module, variant, fragment }) =>
    apiRequest({
      uri: `/odx/translations/modules/${module}/variants/${variant}/fragments/${fragment}`,
    }),
  getDomainPartNumbers: ({ module, variant, vcdQualifier }) =>
    apiRequest({
      uri: `/odx/environments/modules/${module}/variants/${variant}/vcd-qualifiers/${vcdQualifier}/keys`,
    }),
  getPartDetailList: ({ module, variant, key }) =>
    apiRequest({
      uri: `/odx/translations/modules/${module}/variants/${variant}/keys/${key}`,
    }),
  getDomainFragments: ({ module, variant, vcdQualifier }) =>
    apiRequest({
      uri: `/odx/environments/modules/${module}/variants/${variant}/vcd-qualifiers/${vcdQualifier}`,
    }),
}
